import { Directive, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { HisOptionWidget } from '../model/his-widget-option';
import { HisSearchSelectWidget } from '../model/his-widget-search-select';
import { HisTreeSelectWidget } from '../model/his-widget-tree-select';
import { HisMultiSelectWidget } from '../model/his-widget-multiselect';
import { HisOption } from '../model/his-option';


@Directive()
export class HisSearchFormWidgetComponentBase {
    @Input() widget: any; // HisWidgetBase<any>;
    @Input() form: UntypedFormGroup;
    @Input() showErrors: boolean;
    @Input() isFirstInputElement = false;

    get isValid() {
        return this.form.controls[this.widget.id].valid;
    }

    /**
     * Called if any input field except a checkbox has been changed.
     *
     * @param value new input field value
     */
    setValue( value: string | HisOption | any[] ) {
        // Make formgroup model and view model consistent
        console.log( 'Update value of widget', this.widget.id, ': old value =', this.widget.value,
            ', form value =', this.form.value[this.widget.id], 'new value =', value );

        if ( this.widget instanceof HisSearchSelectWidget
            || this.widget instanceof HisTreeSelectWidget
            || this.widget instanceof HisMultiSelectWidget ) {
            this.widget.value = value as any[];
            this.form.value[this.widget.id] = value;
        } else {
            // this.widget.value is already up-to-date
            //assert.strictEqual( this.widget.value, value, 'this.widget.value does not equal new value !' );
            // TODO falls equivalent, auskommentiertes assert und Import löschen
            if (this.widget.value === value) {
                this.form.value[this.widget.id] = value;
            } else {
                throw new Error( 'this.widget.value ' + this.widget.value + ' does not equal new value ' + value + '!' );
            }
        }
        // mark the widget as dirty
        this.form.controls[this.widget.id].markAsDirty();
    }

    /**
     * Called by selecting/deselecting a checkbox.
     *
     * @param $event event
     */
    setOptionValue() {
        let widget = this.widget as HisOptionWidget;
        // this.widget.value has already been updated.
        // So all we have to do here is to keep the form.value consistent:
        let option = widget.value ? widget.option : null;
        console.log( 'Set value of checkbox widget', widget.id, 'to', widget.value, '-> select option', option );
        this.form.value[widget.id] = option;
        // mark the widget as dirty
        this.form.controls[this.widget.id].markAsDirty();
    }
}
